import React from "react";
import { AutoResizerProps } from ".";
import { AutoResizerWrapper } from "./ReactBaseTableWrapper";

/**
 * Decorator component that automatically adjusts the width and height of a single child.
 */
export const AutoResizer = (props: AutoResizerProps) =>
    <AutoResizerWrapper {...props} />;